import { useQuery } from '@tanstack/react-query';
import { fetchQuickReplies, type DmQuickReply } from '../services/dmQuickReplies';
import { DM_QUICK_REPLIES_KEY } from './queryKeys';

const QUICK_REPLIES_STALE_TIME_MS = 5 * 60 * 1000;

// Pass `enabled` from the picker's open state so the list is fetched on first open only.
export function useDmQuickReplies(patientId: string | undefined, enabled: boolean) {
    const { data, error, isLoading, isFetching, refetch } = useQuery<DmQuickReply[]>({
        queryKey: DM_QUICK_REPLIES_KEY(patientId ?? ''),
        queryFn: () => fetchQuickReplies(patientId!),
        enabled: enabled && !!patientId,
        staleTime: QUICK_REPLIES_STALE_TIME_MS
    });

    return { data: data ?? [], isLoading, isFetching, error, refetch };
}
